/** Israeli ID checksum (5–9 digits; padded to 9 with leading zeros). */
export function isValidIsraeliIdChecksum(id: string): boolean {
  if (!/^\d{9}$/.test(id)) return false;
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    const digit = Number(id[i]);
    let mult = i % 2 === 0 ? digit : digit * 2;
    if (mult > 9) mult -= 9;
    sum += mult;
  }
  return sum % 10 === 0;
}

/** Normalize to 9 digits or null if invalid. */
export function normalizeIsraeliId(
  id: string | undefined | null,
): string | null {
  if (!id?.trim()) return null;
  const digits = id.replace(/\D/g, "");
  if (!/^\d{5,9}$/.test(digits)) return null;
  const padded = digits.padStart(9, "0");
  return isValidIsraeliIdChecksum(padded) ? padded : null;
}

/** Client-side validation message, or null when valid. */
export function getIsraeliIdValidationError(
  id: string | undefined | null,
  options?: { required?: boolean },
): string | null {
  const required = options?.required !== false;
  const digits = (id ?? "").replace(/\D/g, "");
  if (!digits) {
    return required ? "שדה זה הינו שדה חובה" : null;
  }
  if (!/^\d{5,9}$/.test(digits)) {
    return "מספר ת.ז חייב להכיל 9 ספרות";
  }
  if (!isValidIsraeliIdChecksum(digits.padStart(9, "0"))) {
    return "תעודת זהות לא תקינה";
  }
  return null;
}
